import DemoRenderer__LegacyDemoInstructions from '@runtime/DemoRenderer';
import InterfaceRenderer__LinkInstructions from '@runtime/TypescriptMetadataRenderer/interface';
import DemoRenderer__LinkInstructions from '@runtime/DemoRenderer';
import legacyImportDemo_4161332628 from "../../../../../packages/component/src/components/date-picker/demo/demo1.js?loadDemo";
import legacyImportDemo_338568663 from "../../../../../packages/component/src/components/date-picker/demo/demo2.js?loadDemo";
import legacyImportDemo_3677705110 from "../../../../../packages/component/src/components/date-picker/demo/demo3.js?loadDemo";
import legacyImportDemo_4206943185 from "../../../../../packages/component/src/components/date-picker/demo/demo4.js?loadDemo";
import legacyImportDemo_2672022160 from "../../../../../packages/component/src/components/date-picker/demo/demo5.js?loadDemo";
import legacyImportDemo_1724212947 from "../../../../../packages/component/src/components/date-picker/demo/demo6.js?loadDemo";
import legacyImportDemo_893552274 from "../../../../../packages/component/src/components/date-picker/demo/demo7.js?loadDemo";
import legacyImportDemo_1559637213 from "../../../../../packages/component/src/components/date-picker/demo/demo8.js?loadDemo";
import legacyImportDemo_3133083036 from "../../../../../packages/component/src/components/date-picker/demo/demo9.js?loadDemo";
import legacyImportDemo_4252586148 from "../../../../../packages/component/src/components/date-picker/demo/demo10.js?loadDemo";
import legacyImportDemo_2323652421 from "../../../../../packages/component/src/components/date-picker/demo/demo11.js?loadDemo";
import legacyImportDemo_1488155238 from "../../../../../packages/component/src/components/date-picker/demo/demo12.js?loadDemo";
import * as React from 'react';
export default {
  DemoRenderer__LegacyDemoInstructions,
  InterfaceRenderer__LinkInstructions,
  DemoRenderer__LinkInstructions,
  legacyImportDemo_4161332628,
  legacyImportDemo_338568663,
  legacyImportDemo_3677705110,
  legacyImportDemo_4206943185,
  legacyImportDemo_2672022160,
  legacyImportDemo_1724212947,
  legacyImportDemo_893552274,
  legacyImportDemo_1559637213,
  legacyImportDemo_3133083036,
  legacyImportDemo_4252586148,
  legacyImportDemo_2323652421,
  legacyImportDemo_1488155238,
  React
};